module.exports = __webpack_public_path__ + "static/media/icon-star.41214ff6.svg";